import { render, staticRenderFns } from "./loginIndex.vue?vue&type=template&id=c88d67fa&scoped=true"
import script from "./loginIndex.vue?vue&type=script&lang=js"
export * from "./loginIndex.vue?vue&type=script&lang=js"
import style0 from "./loginIndex.vue?vue&type=style&index=0&id=c88d67fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88d67fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88d67fa')) {
      api.createRecord('c88d67fa', component.options)
    } else {
      api.reload('c88d67fa', component.options)
    }
    module.hot.accept("./loginIndex.vue?vue&type=template&id=c88d67fa&scoped=true", function () {
      api.rerender('c88d67fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginIndex.vue"
export default component.exports